import { render, staticRenderFns } from "./TheRNSManagerLayout.vue?vue&type=template&id=6c821704"
import script from "./TheRNSManagerLayout.vue?vue&type=script&lang=js"
export * from "./TheRNSManagerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports